import React, { useEffect, useState } from "react";
import styled from "styled-components";
import COLORS from "../common/Colors";
import { MenuOutlined } from "@ant-design/icons";
import Icon from "../Component/Reusable/SideNavIcon";
import { useDispatch, useSelector } from "react-redux";
import useSystemNavigation from "../SysHooks";
import { setIsSideBarCollapsed } from "../Redux/systemSlice";
import { ReactComponent as MenuIcon } from "../assets/Icons/menu_icon.svg";

const StyledAppDiv = styled.div`
  position: fixed;
  left: 0;
  top: 0;
  height: 100%;
  // bottom: 0;
  color: white;
  width: 70px;
  padding: 0px;
  margin: auto;
  background-color: ${COLORS.sidebar};

  .icons {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 1rem;
    padding-top: 10px;
  }
`;

const BoxIcon = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  font-size: 12px;
  text-align: center;
  cursor: pointer;
  border-radius: 0px;
  height: 60px;
  color: #fff;
  &:hover {
    background-color: rgba(255, 255, 255, 0.1);
  }

  &.active {
    background-color: white;
    color: #ffffff;
  }
  span {
    line-height: 1.5;
  }
`;

const SideBarToggleIcon = styled.div`
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  cursor: pointer;
  height: 60px;
  cursor: pointer;
  color: white;
`;

const AppSidebarLayout = () => {
  const dispatch = useDispatch();
  // const [viewSideBar, setViewSideBar] = useState(false)
  const menuList = useSelector((state) => state.systemTracking.menuItem);
  // useEffect(() => {

  // },[menuList])

  const isSideBarCollapsed = useSelector(
    (state) => state.systemTracking.isSideBarCollapsed
  );
  const { goOtherMenu, goHome } = useSystemNavigation();

  const hasSubMenu = (menu) => {
    if (menu.subMenu.length > 0) {
      // setViewSideBar(true)
      return (
        menu.subMenu.length > 0 &&
        menu.subMenu.some((subMenu) => subMenu.access)
      );
    } else {
      // setViewSideBar(false)
      return menu;
    }
  };

  const menuListWithSubmenu = menuList?.filter((menu) => {
    console.log("menu---->", menu);
    return hasSubMenu(menu);
  });

  console.log("menuListWithSubmenu---->", menuListWithSubmenu);

  const isAnyMenuActive = menuListWithSubmenu?.some((menu) => menu.active);

  const isHomeActive = !isAnyMenuActive;

  const handleToggleSideBar = () => {
    dispatch(setIsSideBarCollapsed(!isSideBarCollapsed));
  };

  const handleClickOtherMenu = (menu) => {
    if (isSideBarCollapsed) {
      if (!isSideBarCollapsed) return; // Avoid redundant dispatch
      dispatch(setIsSideBarCollapsed(false));
    } else {
      goOtherMenu(menu); // Ensure goOtherMenu is not triggering state changes that re-render this component unnecessarily
    }
  };

  const handleClickHome = () => {
    dispatch(setIsSideBarCollapsed(false));
    goHome();
  };

  return (
    <>
      <StyledAppDiv>
        <SideBarToggleIcon onClick={handleToggleSideBar}>
          {/* {isSideBarCollapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />} */}
          {/* <MenuOutlined /> */}
          <MenuIcon />
        </SideBarToggleIcon>

        {menuListWithSubmenu.length > 0 && (
          <div className="icons">
            {menuListWithSubmenu.map((menu, index) => (
              <BoxIcon
                key={index}
                className={menu.active ? "active" : ""}
                onClick={() => handleClickOtherMenu(menu)}
              >
                {menu.icon && <Icon name={menu.icon} />}
                <span style={{ color: "#1F243B" }}>{menu.title}</span>
              </BoxIcon>
            ))}
          </div>
        )}
      </StyledAppDiv>
    </>
  );
};

export default AppSidebarLayout;
